import { render, staticRenderFns } from "./Truncated.vue?vue&type=template&id=0db9d6f2&scoped=true"
import script from "./Truncated.vue?vue&type=script&lang=ts"
export * from "./Truncated.vue?vue&type=script&lang=ts"
import style0 from "./Truncated.vue?vue&type=style&index=0&id=0db9d6f2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0db9d6f2",
  null
  
)

export default component.exports